import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
	providedIn: 'root'
})
export class PdfCreationService {
	pdfRequested: Subject<boolean> = new Subject<boolean>();
}
